import { useMemo } from 'react';

import { useProductNutritionData } from '../useProductNutritionData';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Generates a memoized array of formatted nutrition data based on the provided base product.
 *
 * NOTE: The hook omits entries for any nutritional metric that is not valid.
 */
export const useProductMicroNutritionData = (params: Params) => {
  const completeNutritionData = useProductNutritionData(params);

  return useMemo(() => {
    const { calories, totalCarbsG, totalFatG, proteinG } = completeNutritionData; // prettier-ignore

    return [
      ...(proteinG ? [proteinG] : []),
      ...(totalCarbsG ? [totalCarbsG] : []),
      ...(totalFatG ? [totalFatG] : []),
      ...(calories ? [calories] : []),
    ] satisfies NutritionData[];
  }, [completeNutritionData]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = Parameters<typeof useProductNutritionData>[0];

type NutritionData = {
  label: string;
  labelShort?: string;
  value: string | number;
} | null;
